import { render, staticRenderFns } from "./Manifest.template.vue?vue&type=template&id=6209066b&scoped=true&"
var script = {}
import style0 from "./Manifest.template.vue?vue&type=style&index=0&id=6209066b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6209066b",
  null
  
)

export default component.exports